import { ReactNode } from "react";
import { TrackingAttributesType } from "@claroty/utilities/types/trackingAttributes";
import utilStyles from "@claroty/xdome-design-system/styles/utilStyles";

type TrackingContextProps = {
    children: ReactNode;
    trackingAttributes: TrackingAttributesType;
};

// TODO Maybe think of a way to make this render the children directly, without the div, and use some other way to
//  pass the tracking attributes (react context with some reference to it in
//  the child's DOM tree?)
function TrackingContext({ children, trackingAttributes }: TrackingContextProps) {
    return (
        <div className={utilStyles.displayContents} {...trackingAttributes}>
            {children}
        </div>
    );
}

export default TrackingContext;
